/**
 * Service images configuration
 * Consolidates responsive image imports and srcset generation
 */

// Original images (fallback)
import roofRepairs from '@/assets/service-roof-repairs-hero.jpg';
import roofMaintenance from '@/assets/service-roof-maintenance-hero.jpg';
import roofReplacement from '@/assets/service-roof-replacement-new.jpg';
import skylightsVentilation from '@/assets/service-skylights-ventilation-hero.jpg';
import newConstruction from '@/assets/service-new-construction-hero.jpg';

// Responsive WebP variants - Small (400w)
import roofRepairsSmall from '@/assets/service-roof-repairs-hero.jpg?w=400&format=webp';
import roofMaintenanceSmall from '@/assets/service-roof-maintenance-hero.jpg?w=400&format=webp';
import roofReplacementSmall from '@/assets/service-roof-replacement-new.jpg?w=400&format=webp';
import skylightsVentilationSmall from '@/assets/service-skylights-ventilation-hero.jpg?w=400&format=webp';
import newConstructionSmall from '@/assets/service-new-construction-hero.jpg?w=400&format=webp';

// Responsive WebP variants - Medium (800w)
import roofRepairsMedium from '@/assets/service-roof-repairs-hero.jpg?w=800&format=webp';
import roofMaintenanceMedium from '@/assets/service-roof-maintenance-hero.jpg?w=800&format=webp';
import roofReplacementMedium from '@/assets/service-roof-replacement-new.jpg?w=800&format=webp';
import skylightsVentilationMedium from '@/assets/service-skylights-ventilation-hero.jpg?w=800&format=webp';
import newConstructionMedium from '@/assets/service-new-construction-hero.jpg?w=800&format=webp';

// Responsive WebP variants - Large (1200w)
import roofRepairsLarge from '@/assets/service-roof-repairs-hero.jpg?w=1200&format=webp';
import roofMaintenanceLarge from '@/assets/service-roof-maintenance-hero.jpg?w=1200&format=webp';
import roofReplacementLarge from '@/assets/service-roof-replacement-new.jpg?w=1200&format=webp';
import skylightsVentilationLarge from '@/assets/service-skylights-ventilation-hero.jpg?w=1200&format=webp';
import newConstructionLarge from '@/assets/service-new-construction-hero.jpg?w=1200&format=webp';

import { IMAGE_SIZES } from './constants';

export interface ServiceImageConfig {
  src: string;
  srcSet: string;
  sizes: string;
}

const generateSrcSet = (small: string, medium: string, large: string): string => {
  const { BREAKPOINTS } = IMAGE_SIZES;
  return `${small} ${BREAKPOINTS.small}w, ${medium} ${BREAKPOINTS.medium}w, ${large} ${BREAKPOINTS.large}w`;
};

export const serviceImages: Record<string, ServiceImageConfig> = {
  roofRepairs: {
    src: roofRepairs,
    srcSet: generateSrcSet(roofRepairsSmall, roofRepairsMedium, roofRepairsLarge),
    sizes: IMAGE_SIZES.DEFAULT_SIZES,
  },
  roofMaintenance: {
    src: roofMaintenance,
    srcSet: generateSrcSet(roofMaintenanceSmall, roofMaintenanceMedium, roofMaintenanceLarge),
    sizes: IMAGE_SIZES.DEFAULT_SIZES,
  },
  roofReplacement: {
    src: roofReplacement,
    srcSet: generateSrcSet(roofReplacementSmall, roofReplacementMedium, roofReplacementLarge),
    sizes: IMAGE_SIZES.DEFAULT_SIZES,
  },
  skylightsVentilation: {
    src: skylightsVentilation,
    srcSet: generateSrcSet(skylightsVentilationSmall, skylightsVentilationMedium, skylightsVentilationLarge),
    sizes: IMAGE_SIZES.DEFAULT_SIZES,
  },
  newConstruction: {
    src: newConstruction,
    srcSet: generateSrcSet(newConstructionSmall, newConstructionMedium, newConstructionLarge),
    sizes: IMAGE_SIZES.DEFAULT_SIZES,
  },
};

export default serviceImages;
